import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=15a71384&scoped=true"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"
import style0 from "./demo.vue?vue&type=style&index=0&id=15a71384&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a71384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a71384')) {
      api.createRecord('15a71384', component.options)
    } else {
      api.reload('15a71384', component.options)
    }
    module.hot.accept("./demo.vue?vue&type=template&id=15a71384&scoped=true", function () {
      api.rerender('15a71384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/log/demo.vue"
export default component.exports